import React from 'react';
import PropTypes from 'prop-types';

const MobileLandingSection = ({ img, startText, endText, underline, cta, ctaLink, imgClassName = '', underlineType = 'neutral', newTab, className = '' }) => (
  <div className={`mobile-landing__section ${className}`}>
    <div className="mobile-landing__content">
      <div className="mobile-landing__section-icon-container">
        <img className={`mobile-landing__section-icon ${imgClassName}`} src={img} role="presentation" />
      </div>
      <div className="mobile-landing__section-right">
        <div className="mobile-landing__section-text">
          <h3 className="semibold">{startText} </h3>
          <h3
            className={
              `mobile-landing__section-underline-${underlineType} semibold mobile-landing__section-underline`
            }
          >{underline}</h3>
          <h3 className="semibold"> {endText}</h3>
        </div>
        <a href={ctaLink} target={newTab ? '_blank' : '_self'}>
          <button className="btn-primary btn">{cta}</button>
        </a>
      </div>
    </div>
  </div>
);

MobileLandingSection.propTypes = {
  img: PropTypes.string,
  startText: PropTypes.string,
  endText: PropTypes.string,
  underline: PropTypes.string,
  cta: PropTypes.string,
  ctaLink: PropTypes.string,
  imgClassName: PropTypes.string,
  underlineType: PropTypes.string,
  className: PropTypes.string,
  newTab: PropTypes.string
};

export default MobileLandingSection;



// WEBPACK FOOTER //
// ./src/components/onboard/MobileLanding/MobileLandingSection.jsx